import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }

import { defineAsyncComponent, } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexCheckout',
  setup(__props) {

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const CheckoutForm = defineAsyncComponent(() => import("@/components/theme/ecommerce/checkout/CheckoutForm.vue"))
const CheckoutDetail = defineAsyncComponent(() => import("@/components/theme/ecommerce/checkout/CheckoutDetail.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "ECommerce",
      mains: "Checkout",
      title: "Checkout"
    }),
    _createVNode(_unref(Card3), {
      colClass: "container-fluid checkout",
      cardhaderClass: "card-no-border pb-0",
      headerTitle: "true",
      title: "Billing Details"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(CheckoutForm)),
          _createVNode(_unref(CheckoutDetail))
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})